export const ADD_IMAGE = '@image/ADD_IMAGE';